module.exports = __webpack_public_path__ + "97c1759bef4ec5fc7a5b578543d31770.svg";